/**
 * Utility function to capitalize the first letter of a status string
 * @param {string} status - The status string to capitalize
 * @returns {string} - Status with first letter capitalized
 */
export const capitalizeStatus = (status) => {
  if (!status || typeof status !== 'string') return status;
  const trimmed = status.trim();
  if (trimmed.length === 0) return status;
  // Handle special cases
  if (trimmed.toLowerCase() === 'on_hold') return 'On Hold';
  // Capitalize first letter
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
};

/**
 * Format status for display - handles special cases and capitalization
 * @param {string} status - The status string
 * @returns {string} - Formatted status string
 */
export const formatStatus = (status) => {
  if (!status || typeof status !== 'string') return status || '';
  const normalized = status.trim().toLowerCase();
  
  // Map of status values to display names
  const statusMap = {
    'draft': 'Draft',
    'submitted': 'Submitted',
    'pending': 'Pending',
    'reviewing': 'Reviewing',
    'on_hold': 'On Hold',
    'approved': 'Approved',
    'rejected': 'Rejected'
  };
  
  return statusMap[normalized] || capitalizeStatus(status);
};
